import { render } from "./AnnotationsTab.vue?vue&type=template&id=2d122d15&scoped=true"
import script from "./AnnotationsTab.vue?vue&type=script&lang=js"
export * from "./AnnotationsTab.vue?vue&type=script&lang=js"

import "./AnnotationsTab.vue?vue&type=style&index=0&id=2d122d15&lang=scss&scoped=true"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d122d15"]])

export default __exports__